<template>
    <div v-loading="loading">
        <template v-if="clubDetail.info">
            <div class="block">
                <div class="block-left">
                    <preview-picture className="img-head" :src="clubDetail.info.clubHead" />
                    <p v-text="clubDetail.info.clubName"></p>
                    <p style="line-height: 32px">
                        （ID:
                        <input-set-value width="90px" size="small" type="number"
                            :default-value="clubDetail.info.randomId" @my-submit="updateIdFunc" />
                        ）
                    </p>
                </div>
                <table class="block-center">
                    <tr>
                        <td>俱乐部创建人：</td>
                        <td v-text="`${clubDetail.info.creatorName}（${clubDetail.info.creatorId}）`"></td>
                        <td>今日业绩流水：</td>
                        <td v-text="`${numberChip(clubDetail.info.clubTodayAchievement)} 记分牌`"></td>
                        <td>对赌输赢：</td>
                        <td v-text="`${numberChip(clubDetail.info.winClub)}`"></td>
                    </tr>
                    <tr>
                        <td>俱乐部人数：</td>
                        <td>
                            <span v-text="`${clubDetail.info.clubMembers} /`"></span>
                            <input-set-value size="small" type="number" :default-value="clubDetail.info.upperLimit"
                                @my-submit="updateUpperLimit" />
                        </td>
                        <td>今日分成：</td>
                        <td v-text="`${numberChip(clubDetail.info.clubTodayCommission)} 记分牌`"></td>
                        <td>积分房间服务费总值：</td>
                        <td v-text="`${numberChip(clubDetail.info.clubRoomCharge)} 记分牌`"></td>
                    </tr>
                    <tr>
                        <td>推广员人数：</td>
                        <td v-text="clubDetail.info.promoterNumbers"></td>
                        <td>昨日返豆支出：</td>
                        <td v-text="`${numberChip(clubDetail.info.clubTodayChips)} 金豆`"></td>
                        <td>积分房间保险费总值：</td>
                        <td v-text="`${numberChip(clubDetail.info.clubRoomInsureTotal)} 记分牌`"></td>
                    </tr>
                    <tr>
                        <td>基金金豆数：</td>
                        <td v-text="numberChip(clubDetail.info.fund)"></td>
                        <td>今日新增推广员：</td>
                        <td v-text="`${clubDetail.info.promoterTodayNum} 个`"></td>
                        <td>开启战绩返佣/小游戏：</td>
                        <td>
                            <el-switch v-model="clubDetail.info.openRebate" active-color="#13ce66"
                                inactive-color="#ff4949" :active-value="1" :inactive-value="0" active-text="正常"
                                inactive-text="关闭" @change="updateClubConfig({ clubId: clubId, openRebate: $event })" />
                        </td>
                    </tr>
                    <tr>
                        <td>所属联盟：</td>
                        <td>
                            <select-set-value :text="clubDetail.info.tribeName" :list="allUnionList | initSelectList"
                                @my-submit="updateTribe" />
                        </td>
                        <td>对赌仓：</td>
                        <td v-text="`${this.numberChip(clubDetail.info.clubChip)}`"></td>
                        <td>战队积分：</td>
                        <el-button type="primary" @click="editLmb(clubDetail.info, 2)">{{
                            numberChip(clubDetail.info.lmbyue) }}</el-button>
                    </tr>
                    <tr>
                        <td>俱乐部状态：</td>

                        <td>
                            <el-switch v-model="clubDetail.info.clubStatus" active-color="#13ce66"
                                inactive-color="#ff4949" :active-value="0" :inactive-value="1" active-text="正常"
                                inactive-text="关闭" @change="updateClubConfig({ clubId: clubId, status: $event })" />
                        </td>
                        <td>返佣：</td>
                        <td v-text="`${numberChip(clubDetail.info.rebateChip)}`"></td>
                        <td>金币：</td>
                        <el-button type="primary" @click="editLmb(clubDetail.info, 1)">{{
                            numberChip(clubDetail.info.fund) }}</el-button>
                    </tr>
                </table>
            </div>

            <div>
                身份：
                <el-select class="common-el-select-small" v-model="userType" placeholder="请选择" @change="getList()">
                    <el-option v-for="item in userTypes" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                状态：
                <el-select class="common-el-select-small" v-model="state" placeholder="请选择" @change="getList()">
                    <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <div class="common-search">
                    <el-input v-model="searchVal" class="common-el-input" placeholder="输入玩家昵称或ID查询">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-button type="primary" @click="getList()">搜索</el-button>
                </div>
            </div>

            <div class="common-table">
                <el-table :data="clubDetail.beanList" row-key="userId" height="100%">
                    <el-table-column label="编号" type="index" align="center" />
                    <el-table-column label="用户ID" width="150" align="center" prop="randomId" />
                    <el-table-column label="用户昵称" width="150" align="center" prop="nickName" />
                    <el-table-column label="身份" align="center">
                        <template slot-scope="scope">{{ scope.row.userType | userTypeName }}</template>
                    </el-table-column>
                    <el-table-column label="今日业绩" width="150" align="center">
                        <template slot-scope="scope">{{ scope.row.todayAchievement | numberChip }} 记分牌</template>
                    </el-table-column>
                    <el-table-column label="推广玩家数" width="150" align="center" prop="spreadNumbers" />
                    <el-table-column label="金豆余额" width="150" align="center">
                        <template slot-scope="scope">{{ scope.row.chip | numberChip }} 金豆</template>
                    </el-table-column>
                    <el-table-column label="昨日佣豆" width="150" align="center">
                        <template slot-scope="scope">{{ scope.row.todayCommission | numberChip }} 金豆</template>
                    </el-table-column>
                    <el-table-column label="昨日子游戏返佣" width="150" align="center">
                        <template slot-scope="scope">{{ scope.row.todayCommissionLink | numberChip }}</template>
                    </el-table-column>
                    <el-table-column label="钱包状态" align="center" width="150">
                        <template slot-scope="scope">
                            <el-switch :value="scope.row.walletStatus" :active-value="1" :inactive-value="2"
                                inactive-color="red" active-text="正常" inactive-text="停用"
                                @change="showMsgCodeFunc('walletStatus', scope.row, $event)" />
                        </template>
                    </el-table-column>
                    <el-table-column label="账户状态" align="center" width="150">
                        <template slot-scope="scope">
                            <el-switch :value="scope.row.statu" :active-value="1" :inactive-value="0"
                                inactive-color="red" active-text="启用" inactive-text="冻结"
                                @change="showMsgCodeFunc('statu', scope.row, $event)" />
                        </template>
                    </el-table-column>
                    <el-table-column label="登录状态" align="center" width="150">
                        <template slot-scope="scope">
                            <el-switch :value="scope.row.loginStatus" :active-value="1" :inactive-value="0"
                                inactive-color="red" active-text="正常" inactive-text="禁登"
                                @change="showMsgCodeFunc('loginStatus', scope.row, $event)" />
                        </template>
                    </el-table-column>
                    <el-table-column label="用户详细记录" align="center" width="150">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="rowClick(scope.row)">用户详细记录</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="加入时间" width="180" align="center" prop="createTime" />
                </el-table>
            </div>

            <el-pagination class="common-el-pagination" layout="prev,pager,next,jumper" background :page-size="20"
                :pager-count="5" :total="clubDetail.total" :current-page="currentPage"
                @current-change="getList($event)" />

            <div v-if="showMsgCode" class="common-popup-bg">
                <div class="common-popup">
                    <h3>短信验证</h3>
                    <table class="common-popup-table">
                        <tr>
                            <td>
                                <el-input placeholder="请输入验证码" v-model="code"></el-input>
                            </td>
                            <td>
                                <btnCountdown text="发送短信" @my-click="sendCodeFunc" />
                            </td>
                        </tr>
                    </table>
                    <footer>
                        <el-button size="small" @click="closeMsgCode">取消</el-button>
                        <el-button size="small" @click="submitMsgCode" type="primary">确定
                        </el-button>
                    </footer>
                </div>
            </div>
        </template>

        <!-- 修改联盟币弹框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormEditLmb" width="30%">
            <el-form :model="form">
                <el-form-item label="联盟ID">:{{ form.clubId }}</el-form-item>
                <el-form-item label="联盟名称">:{{ form.clubName }}</el-form-item>
                <el-form-item :label="dialogTitle + '余额'">:{{ form.clubLmb | numberChip }}</el-form-item>
                <el-form-item label="变动后余额">:{{ form.biandongLmb | numberChip }}</el-form-item>
                <el-form-item label="类型">:
                    <el-radio-group v-model="form.type" @input="handleInput(form.editJine)">
                        <el-radio v-if="editType == 2" label="1">回收</el-radio>
                        <el-radio label="2">发放</el-radio>
                    </el-radio-group>

                </el-form-item>
                <el-form-item label="金额">
                    <el-input v-model="form.editJine" autocomplete="off" @input="handleInput"
                        style="width: 240px;"></el-input>
                </el-form-item>
            </el-form>
            <!-- dialog弹框底部 -->
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormEditLmb = false">取 消</el-button>
                <el-button type="primary" @click="submitEditLmb">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import inputSetValue from 'components/inputSetValue'
import selectSetValue from 'components/selectSetValue'
import btnCountdown from 'components/btnCountdown'
import previewPicture from 'components/previewPicture'

export default {
    components: {
        inputSetValue,
        selectSetValue,
        btnCountdown,
        previewPicture
    },
    data() {
        return {
            clubId: '',
            loading: false,
            searchVal: '',
            state: '',
            userType: '',
            dialogFormEditLmb: false,
            dialogTitle: "",
            editType: 0,//1=金币 2=联盟币
            form: {
                clubId: 0,
                clubName: '',
                clubLmb: 0,
                biandongLmb: 0,//变动后余额
                type: "1",//修改类型：1==回收:::: 2==发放
                editJine: '',
                editType: '1',//操作类型：1==金币:::: 2==联盟币
                status: 1,//状态
            },
            userTypes: [{
                label: '不限',
                value: ''
            }, {
                label: '推广员',
                value: 1
            }, {
                label: '玩家',
                value: 0
            }],
            status: [{
                label: '不限',
                value: ''
            }, {
                label: '启用',
                value: 1
            }, {
                label: '冻结',
                value: 0
            }],
            currentPage: 1,//当前页
            configOp: '',
            configUserId: '',// 将要修改状态的玩家id
            configRandomId: '',// 将要修改状态的玩家显性id
            code: '',//短信
            showMsgCode: false,//显示发送短信弹窗
            updateType: '',//钱包：walletStatus 账户：statu
        }
    },
    computed: {
        ...mapState('club', ['clubDetail']),
        ...mapState('union', ['allUnionList']),
    },

    created() {
        this.clubId = this.$route.params.id;
        this.getList();
        this.getAllUnionList();
    },
    filters: {
        initSelectList(list) {
            return list.map(item => {
                return {
                    label: item.tribeName,
                    value: item.id
                }
            })
        },
    },
    methods: {
        ...mapActions('club', ['getClubDetail', 'updateClubConfig', 'updateClubRandomId']),
        ...mapActions('union', ['getAllUnionList', 'editClubLmb']),
        ...mapActions('user', ['updateUserState', 'updateWalletClose', 'updateWalletOpen', 'setLoginAllow', 'setLoginForbid']),
        ...mapActions('other', ['sendCodeToMyPhone']),
        // 获取俱乐部详情 玩家列表
        getList(page = 1) {
            this.loading = true;
            this.currentPage = page;

            let params = {
                clubId: this.clubId,
                page,// 翻页时传入页数
                key: this.searchVal,
                statu: this.state,
                userType: this.userType
            };
            this.getClubDetail(params).then(() => {
                this.loading = false;
            });
        },
        rowClick(row) {
            const id = row.randomId;
            this.$router.push({ name: 'integralUser', params: { id: id } })
        },
        numberChip(val) {
            return val / 100;
        },
        submitEditLmb() {
            // 提交联盟币修改
            this.form.editType = this.editType;
            if (this.form.editJine == 0) {
                this.$msg('error', "修改金额不能为0！")
                return;
            }

            this.editClubLmb(this.form)
                .then(res => {
                    //提交数据到vuex
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        setTimeout(() => {
                            this.getList()
                            this.dialogFormEditLmb = false;
                        }, 1000); // 1000毫秒后执行

                    } else {
                        this.$message.error(res.msg)
                    }
                })
                .catch(err => {
                    this.$message.error(err.message);
                });
        },
        // 修改联盟
        updateTribe({ value, cb }) {
            this.updateClubConfig({ clubId: this.clubId, tribeId: value }).then(() => {
                this.getList(this.currentPage);
                this.$message.success('修改成功');
                cb()
            })
        },
        editLmb(tribeDetailFrom, editType) {
            this.dialogFormEditLmb = true;
            this.editType = editType;
            debugger
            if (this.editType == 1) {
                this.dialogTitle = "金币";
                this.form.clubLmb = tribeDetailFrom.fund;
                this.form.biandongLmb = 0;
                this.form.editJine = 0;
                this.form.type = "2";
            } else if (this.editType == 2) {
                this.dialogTitle = "战队积分";
                this.form.clubLmb = tribeDetailFrom.lmbyue;
                this.form.biandongLmb = 0;
                this.form.editJine = 0;
                this.form.type = "1";
            }

            this.form.clubId = tribeDetailFrom.randomId;
            this.form.clubName = tribeDetailFrom.clubName;

            this.form.status = tribeDetailFrom.statu;

        },
        // 修改俱乐部显性ID
        updateIdFunc({ value, cb }) {
            if (value.length !== 6) {
                this.$message.error('您输入的ID有误，请重新输入');
                return
            }
            this.updateClubRandomId({
                clubId: this.clubId,
                newClubRanDomId: value
            }).then(() => {
                this.getList(this.currentPage);
                this.$message.success('修改成功');
                cb()
            })
        },
        // 修改俱乐部上限数
        updateUpperLimit({ value, cb }) {
            if (value < this.clubDetail.info.clubMembers) {
                this.$message.error('不能小于当前俱乐部人数');
                return
            }
            if (value === this.clubDetail.info.upperLimit) {
                this.$message.info('无变动');
                return
            }
            this.updateClubConfig({ clubId: this.clubId, upperLimit: value }).then(() => {
                this.getList(this.currentPage);
                this.$message.success('修改成功');
                cb()
            })
        },
        handleInput(value) {
            value = value.toString().replace(/[^0-9.]/g, '');
            if (value.indexOf('.') > -1) {
                value = value.slice(0, value.indexOf('.') + 3);
            }
            this.form.editJine = Number(value);

            var showCoin = this.form.clubLmb;

            if (this.form.type == 1) {//回收
                this.form.biandongLmb = showCoin - (this.form.editJine * 100);
            } else if (this.form.type == 2) {//增加
                this.form.biandongLmb = (this.form.editJine * 100) + showCoin;
            }


        },
        // 发送短信
        sendCodeFunc(e) {
            let type = 3;// 账户状态
            switch (this.updateType) {
                case 'walletStatus':
                    if (this.configOp === 1) {
                        type = 15;// 启用钱包
                    } else {
                        type = 14;// 冻结钱包
                    }
                    break;
                case 'loginStatus':
                    if (this.configOp === 1) {
                        type = 21;// 允许登录
                    } else {
                        type = 20;// 禁止登录
                    }
                    break;
                default:
                    break;
            }
            this.sendCodeToMyPhone({ err: e.err, type })
        },
        showMsgCodeFunc(type, row, value) {
            this.updateType = type;
            this.configUserId = row.userId;
            this.configRandomId = row.randomId;
            this.configOp = value;
            this.showMsgCode = true;
        },
        submitMsgCode() {
            if (!this.code) {
                this.$message.error('请输入验证码');
                return
            }
            switch (this.updateType) {
                case 'loginStatus':
                    if (this.configOp === 1) {
                        // 允许登录
                        this.setLoginAllow({
                            smsCode: this.code,
                            userId: this.configUserId,
                        }).then(() => {
                            this.getList(this.currentPage);
                            this.$message.success('请求成功');
                            this.closeMsgCode();
                        });
                    } else {
                        // 禁止登录
                        this.setLoginForbid({
                            smsCode: this.code,
                            userId: this.configUserId,
                        }).then(() => {
                            this.getList(this.currentPage);
                            this.$message.success('请求成功');
                            this.closeMsgCode();
                        });
                    }
                    break;
                case 'statu':
                    // 需改账户状态
                    this.updateUserState({
                        code: this.code,
                        op: this.configOp,
                        userId: this.configRandomId,
                    }).then(() => {
                        this.getList(this.currentPage);
                        this.$message.success('请求成功');
                        this.closeMsgCode();
                    });
                    break;
                case 'walletStatus':
                    // 钱包状态
                    if (this.configOp === 1) {
                        // 启用钱包
                        this.updateWalletOpen({
                            smsCode: this.code,
                            userId: this.configUserId,
                        }).then(() => {
                            this.getList(this.currentPage);
                            this.$message.success('请求成功');
                            this.closeMsgCode();
                        });
                    } else {
                        // 冻结钱包
                        this.updateWalletClose({
                            smsCode: this.code,
                            userId: this.configUserId,
                        }).then(() => {
                            this.getList(this.currentPage);
                            this.$message.success('请求成功');
                            this.closeMsgCode();
                        });
                    }
                    break;
                default:
                    break;
            }
        },
        closeMsgCode() {
            this.configUserId = '';
            this.configRandomId = '';
            this.code = '';
            this.showMsgCode = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.block {
    display: flex;
    align-items: center;
    min-height: 230px;
    padding-bottom: 20px;

    &-left {
        min-width: 220px;
        padding-right: 20px;
        text-align: center;
    }

    &-center {
        td {
            height: 34px;
        }

        td:nth-of-type(2) {
            min-width: 200px;
        }

        td:first-of-type {
            text-align: right;
        }

        td:nth-of-type(3) {
            padding-left: 50px;
            text-align: right;
        }

        td:nth-of-type(5) {
            padding-left: 50px;
            text-align: right;
        }
    }
}

:global(.el-select) {
    margin-right: 15px;
}
</style>
